import { useSelector } from 'react-redux'
import classes from './ChatUnread.module.css'
import { useEffect, useState, useMemo } from 'react'

export default function ChatUnread() {
    const activeCase = useSelector(state => state.case.activeCase)


    const [unreadMessages, setUnreadMessages] = useState(null)
    const [unreadDocuments, setUnreadDocuments] = useState(false)


    const selectedProcoDocsAttorney = useSelector(state => state.attorney.selectedProcoDocsAttorney)

    useEffect(() => {
        let atty = activeCase?.attorneys?.find(attorney => selectedProcoDocsAttorney ? attorney.id == selectedProcoDocsAttorney : attorney.is_managing_attorney)      

        if (atty) {
            setUnreadMessages(atty.ecm_unread_messages ? true : false)
            setUnreadDocuments(atty.ecm_unread_documents ? true : false)
        }
    }, [selectedProcoDocsAttorney, activeCase?.attorneys])

    return <>
        {unreadMessages ? <div className={classes.unread}><i className='ti ti-message'></i></div> : ''}
        {unreadDocuments && <div className={classes.unread_doc}><i className="ti ti-file-check"></i></div>}
    </>

    // old functionality
    // const [unreadMessages, setUnreadMessages] = useState(null)
    // const [unreadDocuments, setUnreadDocuments] = useState(false)

    // useEffect(() => {

    //     if (activeCase && activeCase.case_procodocs_chats) {
    //         let unreadItems = activeCase.case_procodocs_chats.filter(item => !item.is_read && item.type == 'attorney')
    //         setUnreadMessages(unreadItems.length)
    //     }

    //     if (activeCase && activeCase.case && activeCase.case.ecm_unread_documents) {
    //         setUnreadDocuments(true)
    //     } else {
    //         setUnreadDocuments(false)
    //     }

    // }, [activeCase?.case_procodocs_chats])

    // return <>
    //     {unreadMessages ? <div className={classes.unread}><i className='ti ti-message'></i></div> : ''}
    //     {unreadDocuments && <div className={classes.unread_doc}><i className="ti ti-file-check"></i></div>}
    // </>
}